import React from 'react';
import { SparklesIcon, XIcon, CheckIcon } from 'lucide-react';
import { upsellRows } from '../data/content';
export function UpsellSection() {
  return <section aria-labelledby="upsell" className="bg-surface px-5 py-20 sm:py-24" data-id="element-266" data-mp="21f9gr0rzkn54">
      <div className="mx-auto max-w-5xl" data-id="element-267" data-mp="1wklrv0t2lqq0">
        <div className="text-center" data-id="element-268" data-mp="1rnljukcnudw9">
          <SparklesIcon className="mx-auto h-10 w-10 text-sun" aria-hidden="true" data-id="element-269" data-mp="1rmkb4mj4a3hp" />
          <h2 id="upsell" className="mt-4 text-3xl font-black uppercase leading-tight text-white sm:text-4xl" data-id="element-270" data-mp="1moiojrmhfm1h">
            ¿Qué agrega el pack ampliado?
          </h2>
        </div>

        <div className="mt-10 overflow-x-auto rounded-3xl border border-line bg-ink" data-id="element-271" data-mp="1dn2exm3hrnyb">
          <table className="w-full min-w-[640px] text-left" data-id="element-272" data-mp="18or5vdl0thh5">
            <thead data-id="element-273" data-mp="18qc175f5t4g2">
              <tr className="border-b border-line text-xs font-black uppercase tracking-widest" data-id="element-274" data-mp="18qu76trmix16">
                <th scope="col" className="px-6 py-4 text-muted" data-id="element-275" data-mp="37z91ti5qzt6g">Situación familiar</th>
                <th scope="col" className="px-6 py-4 text-coral" data-id="element-276" data-mp="330fnxomju05r">
                  <span className="flex items-center gap-1.5" data-id="element-277" data-mp="1qlucqjv9ly60"><XIcon className="h-4 w-4" aria-hidden="true" data-id="element-278" data-mp="1qoyn5yzbpq54" />Sin el recurso adicional</span>
                </th>
                <th scope="col" className="px-6 py-4 text-brand" data-id="element-279" data-mp="1hm78zrf2cg9s">
                  <span className="flex items-center gap-1.5" data-id="element-280" data-mp="1ho0j5govximj"><CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-281" data-mp="1mkil68stz2v6" />Con el recurso adicional</span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-282" data-mp="2acpltk5l9w0e">
              {upsellRows.map(r => <tr key={r.situation} className="border-b border-line last:border-b-0" data-id="element-283" data-mp="2eb563gaacqa4">
                  <th scope="row" className="px-6 py-4 text-base font-black text-white" data-id="element-284" data-mp="20ll7mmnqmf6m">{r.situation}</th>
                  <td className="px-6 py-4 text-base text-muted" data-id="element-285" data-mp="25iuvvyze4ksv">{r.without}</td>
                  <td className="px-6 py-4 text-base font-semibold text-cream" data-id="element-286" data-mp="2t8xiw0og70km">{r.with}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 rounded-3xl border border-sun/40 p-7" data-id="element-287" data-mp="37w5yddoshs2e">
          <h3 className="text-lg font-black uppercase text-sun" data-id="element-288" data-mp="37vedoxwqdeqw">El pack ampliado incluye:</h3>
          <p className="mt-3 text-base text-cream/90" data-id="element-289" data-mp="32xuq37e57pma">[Enumerar los recursos reales del futuro upsell.]</p>
        </div>
      </div>
    </section>;
}